// Suppress DataCloneError from React 19 dev-mode component profiling.
// Performance.measure() tries to structuredClone a component function which fails.
// This only affects dev mode — production builds don't call logComponentRender.
if (process.env.NODE_ENV === 'development') {
  const _measure = performance.measure.bind(performance)
  performance.measure = function (
    name: string,
    startOrOptions?: string | PerformanceMeasureOptions,
    endMark?: string,
  ) {
    try {
      return _measure(name, startOrOptions, endMark)
    } catch (e) {
      if (e instanceof DOMException && e.name === 'DataCloneError') {
        return undefined as unknown as PerformanceMeasure
      }
      throw e
    }
  }
}
